import React from "react";
import { Backdrop, Box, Typography } from "@mui/material/";
import styles from "./styles";
import { useTranslation } from "react-i18next";

const Loading = ({ loadingText, loadingParams }) => {
    const { t } = useTranslation();
    return (
        <Backdrop
            sx={(theme) => ({
                color: "#fff",
                zIndex: theme.zIndex.drawer + 1,
            })}
            open={true}
        >
            <Box sx={styles.spinner}>
                <Box sx={styles.loaderRoller}>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </Box>
                <Typography>
                    {loadingParams &&
                        loadingText &&
                        `${t(loadingText, { ...loadingParams })}`}
                    {!loadingParams && loadingText && `${t(loadingText)}...`}
                    {!loadingParams && !loadingText && `${t("loading")}...`}
                </Typography>
            </Box>
        </Backdrop>
    );
};

export default Loading;
